import { useCallback, useContext } from 'react';

import PersonInPlaceEditor from '@/components/PersonInPlaceEditor';
import { FieldTypes } from '@/components/PersonInPlaceEditor/types';
import usePaymentTypes from '@/hooks/usePaymentTypes';
import PersonContext from '@/pages/Person/PersonContext';
import DataList, { DataRow } from '@/ui/components/DataList';

const PaymentType = () => {
  const { person } = useContext(PersonContext);

  const { refetch: getPaymentTypes } = usePaymentTypes(false);
  const formatPaymentTypes = useCallback(async () => {
    const { data } = await getPaymentTypes();
    if (data?.data)
      return data.data.map(([paymentType]) => ({ label: paymentType, value: paymentType }));
    return [];
  }, [getPaymentTypes]);

  return (
    <div className="relative">
      <PersonInPlaceEditor
        sectionEditor
        fields={[
          {
            key: 'payment_type',
            label: 'Payment Type',
            type: FieldTypes.SELECT,
            options: formatPaymentTypes
          }
        ]}>
        <DataList>
          <DataRow label="Payment Type" content={person.payment_type || 'No payment type'} />
        </DataList>
      </PersonInPlaceEditor>
    </div>
  );
};

export default PaymentType;
